

import { PUB_SUB_EVENTS, subscribe, publish } from '@lib/pubsub';
import { SectionId, HTMLUpdateUtility, Animations } from '@lib/section-utils';
// import { ProductForm } from '@lib/product-form';


if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('[ref="quantityInput"]');
        if (!this._variantCache) this._variantCache = new Map();

        this.blockId = this.dataset.blockId ? this.dataset.blockId : this.sectionId
  
        
        this.section = this.closest('.shopify-section');
        this.savedIndex = 0;
        
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('[data-quantity-form]');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
      
        /* ---------------- Original logic ---------------- */
        this.resetProductFormState();
      
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
      
        this.pendingRequestUrl = productUrl;
      
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;
      
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
      
          callback: (html) => {
            /* ---- Preserve old behavior ---- */
            if (shouldSwapProduct) {
              this.handleSwapProduct(productUrl, shouldFetchFullPage)(html);
            } else {
              this.handleUpdateProductInfo(productUrl)(html);
            }
      
    
          }
        });
      }
      


      resetProductFormState() {
        this.productForms.forEach((productForm) => {
          productForm?.toggleSubmitButton(true);
          productForm?.handleErrorMessage();
        });
        // const productForm = this.productForm;

        // productForm?.toggleSubmitButton(true);
        // productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
          Animations.initAll();
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {

            } else {
              console.error(error);
            }
          });
      }

 
      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(`variant-picker [data-selected-variant="${this.blockId}-${this.dataset.productId}"]`)?.innerHTML;
      
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const newVariantInfo = html.querySelector(`[data-bundle-product-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const oldVariantInfo = document.querySelector(`[data-bundle-product-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);

        const newVariantPopupInfo = html.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const oldVariantPopupInfo = document.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
    

        if (newVariantInfo && oldVariantInfo) { 
          oldVariantInfo.innerHTML = newVariantInfo.innerHTML;
        }
        if (newVariantPopupInfo && oldVariantPopupInfo) { 
          oldVariantPopupInfo.innerHTML = newVariantPopupInfo.innerHTML;
        }
        const ButtonnewVariantInfo = html.querySelector(`[data-bundle-product-variant-button="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        const ButtonoldVariantInfo = document.querySelector(`[data-bundle-product-variant-button="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`);
        if (ButtonnewVariantInfo && ButtonoldVariantInfo) { 
          ButtonoldVariantInfo.innerHTML = ButtonnewVariantInfo.innerHTML;
        } 
        const variantSelects = html.querySelector(`#variant-selects-${this.dataset.productId}-${this.blockId}`);
    
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }

        const targetElement = document.getElementById(
          `bundle-info-${this.sectionId}-${this.blockId}-${this.dataset.productId}`
        );
    
        setTimeout(() => {
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        },100);
          
      }
      get hideVariants() {
        return this._hideVariants = this._hideVariants || this.querySelectorAll('.product-media--variant').length > 0;
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          // Update the data-selected-variant-id on the product-bundle button
          const productBundleButton = document.querySelector(`[data-block-id="${this.blockId}"][data-product-url="${productUrl}"][is="product-bundle"]`);
          if (productBundleButton && variant?.id) {
            productBundleButton.dataset.selectedVariantId = variant.id; 
          }

          if (!variant) {
            this.setUnavailable();
            return;
          }
          
          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}-${this.productId}`);
            const destination = this.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('price-sticky');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('ProductInventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Sku');

          if (this.querySelector(`#Quantity-Rules-${this.sectionId}-${this.productId}`)) {
            updateSourceFromDestination('Quantity-Rules');
            updateSourceFromDestination('Quantity-Form');
          }
          // updateSourceFromDestination('Quantity-Form');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.sectionId}-${this.productId}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.sectionId}-${this.productId}`)?.classList.remove('hidden');

          // this.productForm?.toggleSubmitButton(
          //   html.getElementById(`ProductSubmitButton-${this.sectionId}-${this.productId}`)?.hasAttribute('disabled') ?? true,
          //   window.variantStrings.soldOut
          // );
         this.productForms.forEach((productForm) => {
          // Check if the current form in the loop belongs to the sticky bar
          const isStickyForm = productForm.closest('sticky-addtocart') !== null || (productForm.id && productForm.id.toLowerCase().includes('sticky'));

          if (isStickyForm) {
            const stickyBtn = html.getElementById(`StickyProductSubmitButton-${this.sectionId}-${this.productId}`);
            // Only update if the sticky button actually exists in the fetched HTML
            if (stickyBtn) {
              productForm?.toggleSubmitButton(
                stickyBtn.hasAttribute('disabled'),
                window.variantStrings.soldOut
              );
            }
          } else {
            // This is the main product form
            const mainBtn = html.getElementById(`ProductSubmitButton-${this.sectionId}-${this.productId}`);
            productForm?.toggleSubmitButton(
              mainBtn?.hasAttribute('disabled') ?? true,
              window.variantStrings.soldOut
            );
          }
        });


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
          Animations.initAll();
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#BuyButtons-ProductForm-${this.dataset.section}-${this.productId}, #Sticky-BuyButtons-ProductForm-${this.dataset.section}-${this.productId}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
        
          input.value = variantId ?? '';
          input.removeAttribute('disabled');
          input.dispatchEvent(new Event('change', { bubbles: true }));

        });
        const formSelector = `#Bundle-ProductForm-${this.sectionId}-${this.blockId}`;
        if(!formSelector) return;
        const formEl = document.querySelector(formSelector);
        if (!formEl) {
          console.warn("Bundle form not found:", formSelector);
          return;
        }
        const input = formEl.querySelector(
          `input.product-variant-id[data-product-handle="${this.dataset.productHandle}"]`
        );
      
        
        if (!input) {
          return;
        }else{
          input.value = variantId ?? "";
        }

      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForms.forEach((productForm) => {
          productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        });
        // this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['ProductInventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules','price']
          .map((id) => `#${id}-${this.sectionId}-${this.productId}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));

       const priceWrapper = document.querySelector(`[data-bundle-popup-variant-info="${this.sectionId}-${this.blockId}-${this.dataset.productId}"]`)?.querySelector('.product-price');
              // 🔹 remove existing badge if present
      if(!priceWrapper) return;
              priceWrapper.querySelector('.product-cardbadge')?.remove();

              // 🔹 add badge only when needed
              priceWrapper.insertAdjacentHTML(
                'beforeend',
                `<span class="product-cardbadge on-sale text-xxsmall">
                  ${window.variantStrings.unavailable}
                </span>`
      );
        
       
      }

      updateMedia(parsedHTML, variantFeaturedMediaId) {

        if (!variantFeaturedMediaId) return;

        const id = 'MediaGallery';
        const source = parsedHTML.getElementById(`${id}-${this.sectionId}-${this.productId}`);
        const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.removeAttribute('hidden');


          let primarySlider = destination.querySelector('[product-media-gallery]');

          if (primarySlider) {
            this.mainSwiper = window.SwiperSlide(primarySlider, JSON.parse(primarySlider.getAttribute('data-swiper')));
            const isMobile = window.innerWidth < 768;

            if (isMobile) {
              // Destroy Swiper if exists
              if (this.mainSwiper) {
                this.mainSwiper.destroy(true, true);
                this.mainSwiper = null;
              }
            } else {
              // Desktop: init Swiper if not exists
              if (!this.mainSwiper) this.initSwiper();
            }
            
          }

        }

      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        } 
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        // const currentVariantId = this.productForm?.variantIdInput?.value;
        const currentVariantId = [...this.productForms][0]?.variantIdInput?.value;
        if (!currentVariantId) return;
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => { });
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}-${this.productId}`);
        const selectors = ['[data-product-quantity]', '.quantity-rules', '.quantity-label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.[data-product-quantity]') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      get bundlePopupSwiper() {
        const bundlePopup = document.querySelector('bundle-popup');
        return bundlePopup && bundlePopup.swiper ? bundlePopup.swiper : null;
      }

      // get productForm() {
      //   return this.querySelector(`product-form`);
      // }
      get productForms() {
        return this.querySelectorAll('product-form');
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector(`#variant-selects-${this.dataset.productId}-${this.blockId}`);
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }

    }
  );
}

if (!customElements.get('sticky-addtocart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.mainFormId;
      this.close = this.querySelector('[data-close]');
      this.targetElement = document.getElementById(this.formId);
      this.footer = document.querySelector('footer');

      // 1. Grab the sticky form and its submit button
      this.stickyForm = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');

      // 2. Bind the sync function so it fires right before the form submits
      this.syncQuantity = this.syncQuantity.bind(this);
      if (this.submitButton && this.stickyForm) {
        this.submitButton.addEventListener('click', this.syncQuantity);
      }

      if (!this.targetElement) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleClose = this.handleClose.bind(this);

      window.addEventListener('scroll', this.handleScroll);

      if (this.close) {
        this.close.addEventListener('click', this.handleClose);
      }

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);

      if (this.close) {
        this.close.removeEventListener('click', this.handleClose);
      }
      if (this.submitButton) {
        this.submitButton.removeEventListener('click', this.syncQuantity);
      }
    }

    syncQuantity() {
      let mainQtyInput = null;
      
      // Attempt to find the specific quantity input tied to the main product form
      if (this.targetElement) {
        const productInfo = this.targetElement.closest('product-info');
        if (productInfo) {
          mainQtyInput = productInfo.querySelector('[name="quantity"]') || productInfo.querySelector('[ref="quantityInput"]');
        }
      }

      // Fallback: grab the first available quantity input if the structural lookup fails
      if (!mainQtyInput) {
        mainQtyInput = document.querySelector('product-info [name="quantity"]') || document.querySelector('product-info [ref="quantityInput"]');
      }

      // If we found the main quantity and we have a sticky form, sync them
      if (mainQtyInput && this.stickyForm) {
        let hiddenQty = this.stickyForm.querySelector('input[name="quantity"]');
        
        // Create the hidden input if it doesn't exist yet
        if (!hiddenQty) {
          hiddenQty = document.createElement('input');
          hiddenQty.type = 'hidden';
          hiddenQty.name = 'quantity';
          this.stickyForm.appendChild(hiddenQty);
        }
        
        // Sync the value
        hiddenQty.value = mainQtyInput.value;
      }
    }

    handleScroll() {
      if (this.classList.contains('hidden')) return;

      const rect = this.targetElement.getBoundingClientRect();
      let footerVisible = false;

      if (this.footer) {
        const footerRect = this.footer.getBoundingClientRect();
        footerVisible = footerRect.top < window.innerHeight;
      }

      if (footerVisible) {
        this.classList.remove('is-visible');
        return;
      }

      if (rect.bottom <= 0) {
        this.classList.add('is-visible');
      } else if (rect.top >= 0) {
        this.classList.remove('is-visible');
      }
    }

    handleClose() {
      this.classList.add('hidden');
      this.classList.remove('is-visible');
    }
  }

  customElements.define('sticky-addtocart', StickyAddToCart);
}